import { CoreType } from "../../Core/Core.Interfaces";
import { DayOfWeek } from "../../Shared/DateAndTime.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const Conversions00Table: GenericTableSchemaInterface = {
  id: "conversions-00",
  name: "Conversions 00",
  description: "This table contains data regarding conversions and referrals.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Org Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Location FMS ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Location Name",
      variable: VarKey.LocationName
    },
    c04: {
      name: "User ID",
      variable: VarKey.UserId
    },
    c05: {
      name: "Lease Rent",
      variable: VarKey.LeaseRent
    },
    c06: {
      name: "Lease Start Date",
      variable: VarKey.LeaseStartDate
    },
    c07: {
      name: "Lease End Date",
      variable: VarKey.LeaseEndDate
    },
    c08: {
      name: "Unit Length",
      variable: VarKey.UnitLength
    },
    c09: {
      name: "Unit Width",
      variable: VarKey.UnitLength
    },
    c10: {
      name: "Unit Rate",
      variable: VarKey.UnitRate
    },
    c11: {
      name: "Provided Referral"
    },
    c12: {
      name: "Source: spot Rent"
    },
    c13: {
      name: "Source: Abandoned Cart Message"
    },
    c14: {
      name: "Source: Inventory Carousel"
    },
    c15: {
      name: "Source: In-Chat Referral"
    },
    c16: {
      name: "Source: spot Referral"
    },
    c17: {
      name: "Initial Date"
    },
    c18: {
      name: "Source: Voice"
    }
  }
};
